import type { CSSProperties } from 'react';
import styles from './Chart.module.css';

export type TooltipRow = {
  readonly key: string;
  readonly label: string;
  readonly display: string;
  readonly color: string;
  readonly dashed?: boolean;
};

const EDGE_SHARE = 0.25;

const alignmentOf = (position: number): string => {
  if (position < EDGE_SHARE) return 'start';
  if (position > 1 - EDGE_SHARE) return 'end';
  return 'center';
};

export const ChartTooltip = ({
  title,
  rows,
  position,
}: {
  title: string;
  rows: readonly TooltipRow[];
  position: number;
}) => (
  <div
    className={styles['tooltip']}
    data-align={alignmentOf(position)}
    style={{ '--tooltip-at': String(position) } as CSSProperties}
    role="status"
  >
    <span className={styles['tooltipTitle']}>{title}</span>
    {rows.map((row) => (
      <span key={row.key} className={styles['tooltipRow']}>
        <span
          className={styles['key']}
          data-mark={row.dashed === true ? 'dash' : 'line'}
          style={{ color: row.color }}
          aria-hidden="true"
        />
        <strong>{row.display}</strong>
        <span className={styles['tooltipLabel']}>{row.label}</span>
      </span>
    ))}
  </div>
);
